import type { ReactNode } from 'react'
import { usePermission } from '@/hooks/usePermission'

export interface PermissionGateProps {
  /** Permission code, e.g. `payroll:approve`. Omit to always render. */
  permission?: string
  children: ReactNode
  /** Rendered instead when the permission is missing. Defaults to nothing. */
  fallback?: ReactNode
}

/**
 * Hides UI the user cannot use.
 *
 * Hiding, not disabling: a disabled button still advertises a capability the user does
 * not have. This is presentation only — the backend enforces the same permission with
 * `@PreAuthorize`, so bypassing this in devtools achieves nothing.
 */
export function PermissionGate({ permission, children, fallback = null }: PermissionGateProps) {
  return usePermission(permission) ? <>{children}</> : <>{fallback}</>
}
